import { render, staticRenderFns } from "./Inicio2.vue?vue&type=template&id=5cdf5ac4&"
import script from "./Inicio2.vue?vue&type=script&lang=js&"
export * from "./Inicio2.vue?vue&type=script&lang=js&"
import style0 from "./Inicio2.vue?vue&type=style&index=0&id=5cdf5ac4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports